export default "__VITE_ASSET__CXbrwKb$__"